<div class="div-27 mb-3">{{reportPlaceHolders['LBL_REPORT_CUSTOM_1']}} </div>
<div class="merchant-details-card">
    <div class="merchant-content">
        <div class="merchant-image" *ngIf="dealimage">
            <img [src]="dealimage" alt="Preview" class="merchant-logo">
        </div>

        <div class="merchant-info">
            <div class="merchant-header">
                <h2>{{ deal.product_name }}</h2>
                <mat-chip style="margin-left: 10px;" [ngClass]="getStatusClass(deal.status)">
                    {{ getStatusLabel(deal.status) }}
                </mat-chip>
            </div>

            <p class="description">{{ deal.product_description }}</p>

            <div class="merchant-details">
                <div class="detail-row"><span class="label">Created On:</span> <span class="value">{{ deal.created_date
                        }}</span></div>
                <div class="detail-row"><span class="label">{{reportPlaceHolders['LBL_DATE_FROM']}}:</span> <span class="value">{{
                        deal.available_from }}</span></div>
                <div class="detail-row"><span class="label">{{reportPlaceHolders['LBL_DATE_TO']}}:</span> <span class="value">{{
                        deal.available_to }}</span></div>
                <div class="detail-row"><span class="label">Coupon Code:</span> <span class="value">{{ deal.coupon_code
                        }}</span></div>
            </div>

            <button class="export-btn" (click)="exportToPDF()">{{reportPlaceHolders['LBL_lower_Deals_Claimed']}}</button>
            <button style="margin-left: 5px;" class="export-btn" (click)="goBack()">{{reportPlaceHolders['LBL_lower_Favourites']}}</button>
        </div>
    </div>
</div>
<p> <span class="event-icon">
        <ng-container [ngSwitch]="event.eventType">
            <svg *ngSwitchCase="'DEAL_FAVOURITE_EVENT'" xmlns="http://www.w3.org/2000/svg" style="height: 1rem;"
                viewBox="0 0 512 512">
                <path fill="#ee3a3a"
                    d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" />
            </svg>
            <svg *ngSwitchCase="'DEAL_CLICK_EVENT'" xmlns="http://www.w3.org/2000/svg" style="height: 1rem;"
                viewBox="0 0 384 512">
                <path fill="#517eb8"
                    d="M0 192l176 0L176 0 160 0C71.6 0 0 71.6 0 160l0 32zm0 32L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-128-192 0L0 224zm384-32l0-32C384 71.6 312.4 0 224 0L208 0l0 192 176 0z" />
            </svg>
            <svg *ngSwitchCase="'DEAL_IMPRESSIONS_EVENT'" xmlns="http://www.w3.org/2000/svg" style="height: 1rem;"
                viewBox="0 0 576 512">
                <path fill="#5b80d7"
                    d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
            </svg>
            <svg *ngSwitchCase="'REPEATED_DEAL_CLICK'" xmlns="http://www.w3.org/2000/svg" style="height: 1rem;"
                viewBox="0 0 512 512">
                <path fill="#4f6da1"
                    d="M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96l160 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32l0 32L160 64C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96l-160 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 160 0c88.4 0 160-71.6 160-160z" />
            </svg>
            <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" style="height: 1rem;" viewBox="0 0 512 512">
                <path fill="#667ea9"
                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
            </svg>
        </ng-container>
        {{ event.eventType }}
    </span></p>
<div class="table-container">
    <table class="event-table">
        <thead>
            <tr>
                <!-- <th>Event Type</th> -->
                <!-- <th>User ID</th> -->
                <th>UDI</th>
                <th>Age</th>
                <!-- <th>DOB</th> -->
                <th>Gender</th>
                <th>Event Date</th>
                <th>Cost</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let event of paginatedEvents">
                <!-- <td><span class="event-icon">
                        <ng-container [ngSwitch]="event.eventType">
                            <svg *ngSwitchCase="'DEAL_FAVOURITE_EVENT'" xmlns="http://www.w3.org/2000/svg"
                                style="height: 1rem;" viewBox="0 0 512 512">
                                <path fill="#ee3a3a"
                                    d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" />
                            </svg>
                            <svg *ngSwitchCase="'DEAL_CLICK_EVENT'" xmlns="http://www.w3.org/2000/svg"
                                style="height: 1rem;" viewBox="0 0 384 512">
                                <path fill="#517eb8"
                                    d="M0 192l176 0L176 0 160 0C71.6 0 0 71.6 0 160l0 32zm0 32L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-128-192 0L0 224zm384-32l0-32C384 71.6 312.4 0 224 0L208 0l0 192 176 0z" />
                            </svg>
                            <svg *ngSwitchCase="'DEAL_IMPRESSIONS_EVENT'" xmlns="http://www.w3.org/2000/svg"
                                style="height: 1rem;" viewBox="0 0 576 512">
                                <path fill="#5b80d7"
                                    d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
                            </svg>
                            <svg *ngSwitchCase="'REPEATED_DEAL_CLICK'" xmlns="http://www.w3.org/2000/svg"
                                style="height: 1rem;" viewBox="0 0 512 512">
                                <path fill="#4f6da1"
                                    d="M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96l160 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32l0 32L160 64C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96l-160 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 160 0c88.4 0 160-71.6 160-160z" />
                            </svg>
                            <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" style="height: 1rem;"
                                viewBox="0 0 512 512">
                                <path fill="#667ea9"
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                            </svg>
                        </ng-container>
                        {{ event.eventType }}
                    </span></td> -->
                <!-- <td>{{ event.userId }}</td> -->
                <td>{{ event.udi ? '****' + event.udi.slice(-4) : '-' }}</td>
                <td>{{ event.age }}</td>
                <!-- <td>{{ event.dob }}</td> -->
                <td>{{ event.gender }}</td>
                <td>{{ event.eventDate | date: 'medium' }}</td>
                <td>{{ event.cost | currency }}</td>
            </tr>
        </tbody>
    </table>

    <!-- Pagination -->
    <div class="pagination">
        <!-- <button (click)="prevPage()" [disabled]="currentPage === 1">Previous</button>
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button> -->
        <div style="display: flex; align-items: center; justify-content: center; gap: 16px;">
            <button (click)="prevPage()" [disabled]="currentPage === 1" style="font-size: 20px;padding: 0px 5px;">
                &#8592;
            </button>

            <div style="padding: 8px 16px; background-color: #ffffff; border-radius: 8px;">
                Page {{ currentPage }} of {{ totalPages }}
            </div>

            <button (click)="nextPage()" [disabled]="currentPage === totalPages"
                style="font-size: 20px;padding: 0px 5px;">
                &#8594;
            </button>
        </div>
    </div>
</div>